import config from "@/lib/config";
import connectRedis from "@/lib/connectRedis";
import { createCipheriv, createDecipheriv, randomBytes } from "crypto";
import jwt from "jsonwebtoken";

export default class PasswordToken {
  constructor(req, res) {
    this.req = req;
    this.res = res;
    this.redis = connectRedis(
      {
        host: process.env.REDIS_HOST || config.passwordToken.redis?.host,
        port: process.env.REDIS_PORT || config.passwordToken.redis?.port,
        keyPrefix: config.passwordToken.redis.prefix,
        db: config.passwordToken.redis?.db,
      },
      config.passwordToken?.redis?.cluster
    );
  }

  generateToken() {
    return randomBytes(16).toString("hex");
  }

  generateEncryptionKey() {
    return randomBytes(32);
  }

  encrypt(text, encryptionKey) {
    const iv = randomBytes(config.passwordToken.ivLength);
    const cipher = createCipheriv(
      config.passwordToken.algorithm,
      Buffer.from(encryptionKey, "hex"),
      iv
    );
    let encrypted = cipher.update(text);
    encrypted = Buffer.concat([encrypted, cipher.final()]);
    return iv.toString("hex") + ":" + encrypted.toString("hex");
  }

  decrypt(text, encryptionKey) {
    const textParts = text.split(":");
    const iv = Buffer.from(textParts.shift(), "hex");
    const encryptedText = Buffer.from(textParts.join(":"), "hex");
    const decipher = createDecipheriv(
      config.passwordToken.algorithm,
      Buffer.from(encryptionKey, "hex"),
      iv
    );
    let decrypted = decipher.update(encryptedText);
    decrypted = Buffer.concat([decrypted, decipher.final()]);
    return decrypted.toString();
  }

  async getValue(jwtToken) {
    // return mailAddress
    try {
      // key : jwtToken
      const verifiedToken = jwt.verify(
        jwtToken,
        config.passwordToken.jwtSecret
      );
      const token = verifiedToken.token;
      const encryptionKey = verifiedToken.encryptionKey;
      const encryptedText = await this.redis.get(token);
      const decryptedText = this.decrypt(encryptedText, encryptionKey);
      return decryptedText;
    } catch (e) {
      console.log("password token get value error", e);
    }
  }

  async publish(key) {
    // key : mailAddress
    const token = this.generateToken();
    const encryptionKey = this.generateEncryptionKey();
    const encryptedText = this.encrypt(key, encryptionKey);
    await this.redis
      .multi()
      .set(token, encryptedText)
      .expire(token, config.passwordToken.maxAge)
      .exec();
    const jwtToken = jwt.sign(
      { token, encryptionKey },
      config.passwordToken.jwtSecret
    );
    return jwtToken;
  }

  async verify(jwtToken) {
    const res = await this.getValue(jwtToken);
    return res?.length > 0;
  }

  async delete(jwtToken) {
    try {
      const verifiedToken = jwt.verify(
        jwtToken,
        config.passwordToken.jwtSecret
      );
      const token = verifiedToken.token;
      await this.redis.del(token);
    } catch (e) {
      console.log("password token delete error", e);
    }
  }
}
